import { Button, Input, Popconfirm, Spin, Table } from 'antd'
import Axios from 'axios'
import React from 'react'
import Item from '../../component/alert/row'

interface IData {
    connectionFail: Array<String>
    vibrationAlert: Array<String>
    angleAlert: Array<String>
    batteryAlert: Array<String>
    monitoringList: Array<String>
    date: Date
    from: Date
    to: Date
}

const EditableContext = React.createContext<any>(null)

const Component: React.FC<any> = (props) => {
    const [state, setState] = React.useState({
        data: {} as any,
        editingKey: '' as any,
        input: {
            name: '',
            value: '',
        },
        loading: false,
    })

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            width: '25%',
            editable: true,
            render: (text: any, record: any) => {
                const editable = isEditing(record)
                return editable ? (
                    <Input
                        value={state.input.name}
                        onChange={(evt) => {
                            const v = { ...state.input }
                            v.name = evt.target.value
                            setState({
                                ...state,
                                input: v,
                            })
                        }}
                    />
                ) : (
                    text
                )
            },
        },
        {
            title: 'Value',
            dataIndex: 'value',
            width: '15%',
            editable: true,
            render: (text: any, record: any) => {
                const editable = isEditing(record)
                return editable ? (
                    <Input
                        value={state.input.value}
                        onChange={(evt) => {
                            const v = { ...state.input }
                            v.value = evt.target.value
                            setState({
                                ...state,
                                input: v,
                            })
                        }}
                    />
                ) : (
                    text
                )
            },
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            render: (text: any, record: any) => {
                const { editingKey } = state
                const editable = isEditing(record)
                return editable ? (
                    <span>
                        <Button style={{ marginRight: 8 }} onClick={() => save(record.key)} type="link">
                            Save
                        </Button>
                        <Popconfirm title="Sure to cancel?" onConfirm={() => cancel()}>
                            <Button type="link">Cancel</Button>
                        </Popconfirm>
                    </span>
                ) : (
                    <div>
                        <Button type="link" onClick={() => edit(record.key)} disabled={editingKey !== ''}>
                            Edit
                        </Button>
                        {/* <Button type="link" onClick={() => deleteRow(record._id)} disabled={editingKey !== ''}>
                            Delete
                        </Button> */}
                    </div>
                )
            },
        },
    ]
    const isEditing = (record: any) => record.key === state.editingKey

    const save = (key: any) => {
        const newData = state.data
        newData[key] = state.input.value
        console.log(newData)
        Axios.put(`/config/${newData._id}`, newData)
            .then((res) => {
                setState({ ...state, data: newData, editingKey: '', input: { name: '', value: '' } })
            })
            .catch((err) => console.error(err))
    }

    const edit = (key: any) => {
        const input = state.data[key]
        setState({ ...state, editingKey: key, input: { value: input, name: key } })
    }

    const cancel = () => {
        setState({ ...state, editingKey: '', input: { name: '', value: '' } })
    }

    React.useEffect(() => {
        Axios.get('/config')
            .then((res: any) => {
                setState((state) => ({
                    ...state,
                    data: res.data,
                }))
            })
            .catch((err) => console.error(err))
    }, [])

    return (
        <div>
            {/* <Button onClick={handleAdd} type="primary" style={{ marginBottom: 16 }} disabled={state.editingKey !== ''}>
                Add a row
            </Button> */}
            <Button
                onClick={props.forceUpdate}
                type="primary"
                style={{ marginBottom: 16 }}
                disabled={state.editingKey !== ''}
            >
                Force Update
            </Button>
            <EditableContext.Provider value={props.form}>
                <Table
                    bordered
                    dataSource={[
                        { name: 'Low Battery', value: state.data.battery, key: 'battery' },
                        { name: 'Hour', value: state.data.hour, key: 'hour' },
                    ]}
                    pagination={{
                        onChange: cancel,
                    }}
                    columns={columns}
                />
            </EditableContext.Provider>
        </div>
    )
}

const AlertPage: React.FC<any> = (props) => {
    const [state, setState] = React.useState({
        data: null as IData | null,
        loading: false,
    })

    React.useEffect(() => {
        setState((prev) => ({ ...prev, loading: true }))
        Axios.get('/alert')
            .then((res) => {
                setState((prev) => ({ ...prev, data: res.data }))
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setState((prev) => ({ ...prev, loading: false }))
            })
    }, [])

    const forceUpdate = () => {
        setState({
            ...state,
            loading: true,
        })
        Axios.post('/alert/force')
            .then((res: any) => {
                setState({ ...state, data: res.data })
            })
            .catch((err) => {
                console.error(err)
            })
            .finally(() => {
                setState({
                    ...state,
                    loading: false,
                })
            })
    }

    return (
        <div>
            <Component forceUpdate={forceUpdate} />
            <Spin spinning={state.loading} style={{ marginTop: '20px' }}>
                {state.data && (
                    <table style={{ width: '80%' }}>
                        <thead>
                            <tr>
                                <th style={{ width: '25%' }}>Detect Item(s)</th>
                                <th style={{ width: '25%' }}>Number of Sensors</th>
                                <th style={{ width: '50%' }}>Sensor ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            <Item item="Connection Fail" sensor={state.data.connectionFail} />
                            <Item item="Vibration Alert" sensor={state.data.vibrationAlert} />
                            <Item item="Angle Alert" sensor={state.data.angleAlert} />
                            <Item item="Battry Alert" sensor={state.data.batteryAlert} />
                        </tbody>
                    </table>
                )}
            </Spin>
        </div>
    )
}

export default AlertPage
